import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import StudentProfileComp from "./Component/StudentProfileComp"

const StudentProfile =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <StudentProfileComp />
        </div>
        <Footer />
        </>
    )
}

export default StudentProfile